import { default as angular } from "angular";
import uiRouter from "@uirouter/angularjs/lib-esm";

import { moduleName as recordsModuleName } from "../records";
import { routeConfig } from "./routes";
import {
  vsComponentName as ContractInstancesComponentName,
  contractInstanceComponentOptions,
} from "./views/Instances";
import {
  vsComponentName as RelationshipGridComponentName,
  relationshipGridComponentOptions,
} from "./views/relationship";

import {
  vsComponentName as GamingRelationshipGridComponentName,
  gamingRelationshipGridComponentOptions,
} from "./views/gamingRelationship";
import {
  vsName as ContractInstancesDetailComponentName,
  contractInstanceDetailComponentOptions,
} from "./views/Instances/Detail";
import {
  vsComponentName as BulkLogComponentName,
  bulkLogComponentOptions,
} from "./views/bulkLog";
import {
  vsComponentName as BulkLogResultComponentName,
  bulkLogResultComponentOptions,
} from "./views/bulkLog/patchBulkResults";
import {
  vsComponentName as MachineDetailContractEditComponentName,
  contractEditComponentOptions,
} from "./views/types/contract/edit";

import {
  vsComponentName as MachineDetailMachinesEditComponentName,
  MachineDetailMachinesEditComponentOptions,
} from "./views/machines/edit";

import {
  vsComponentName as MachineDetailMachinesViewComponentName,
  MachineDetailMachinesViewComponentOptions,
} from "./views/machines";

import {
  SelectContractModalService,
  vsServiceName as selectContractModalServiceName,
  selectContractModalComponentOptions,
  vsComponentName as SelectContractModalComponentOptionsName,
} from "./shared/components/selectContractModal";

import { vsModuleName as configModuleName } from "./configs/module";
import {
  contractPatchBulkComponentOptions,
  vsComponentName as contractPatchBulkComponentName,
} from "./views/patchBulk";
import {
  contractGridComponentOptions,
  vsComponentName as contractGridComponentName,
} from "./views/grid";
import {
  vsComponentName as ContractPatchBulkResultName,
  contractPatchBulkResultComponentOptions,
} from "./views/patchBulk/patchBulkResults";

import {
  vsComponentName as contractInfoComponentName,
  contractInfoComponentOptions,
} from "./views/infoNew";

import {
  vsDirectiveName as contractInfoDirectiveName,
  contractDetailDirectiveFactory,
} from "./views/infoNew/contractInfoDirective";

import {
  vsName as ContractMasterDetailComponentName,
  contractMasterDetailComponentOptions,
} from "./views/types/masterAgreement/Detail";
import {
  vsComponentName as contractMasterAgreementEditComponentName,
  contractMasterAgreementEditComponentOptions,
} from "./views/types/masterAgreement/edit";
import {
  vsComponentName as gamingContractEditComponentName,
  gamingContractEditComponentOptions,
} from "./views/types/gamingContract/edit";
import {
  vsName as GamingContractMasterDetailComponentName,
  gamingContractMasterDetailComponentOptions,
} from "./views/types/gamingMasterAgreement/Detail";
import {
  vsComponentName as gamingContractMasterAgreementEditComponentName,
  gamingContractMasterAgreementEditComponentOptions,
} from "./views/types/gamingMasterAgreement/edit";


import {
  vsComponentName as contractDetailComponentName,
  contractDetailComponentOptions,
} from "./views/types/contract/detail";
import { relationshipEditComponentOptions, vsComponentName as relationshipEditComponentName } from "./views/relationship/edit";
import { gamingRelationshipEditComponentOptions, vsComponentName as gamingRelationshipEditComponentName } from "./views/gamingRelationship/edit";

export const vsName = "SlotTrak.Contract";

angular
  .module(vsName, [uiRouter, recordsModuleName, configModuleName, "ui.tinymce"])
  .config(routeConfig)
  .directive(contractInfoDirectiveName, contractDetailDirectiveFactory)
  .component(RelationshipGridComponentName, relationshipGridComponentOptions)
  .component(relationshipEditComponentName, relationshipEditComponentOptions)
  .component(GamingRelationshipGridComponentName, gamingRelationshipGridComponentOptions)
  .component(gamingRelationshipEditComponentName, gamingRelationshipEditComponentOptions)
  .component(ContractInstancesComponentName, contractInstanceComponentOptions)
  .component(
    ContractInstancesDetailComponentName,
    contractInstanceDetailComponentOptions
  )
  .component(BulkLogComponentName, bulkLogComponentOptions)
  .component(BulkLogResultComponentName, bulkLogResultComponentOptions)
  .component(
    MachineDetailContractEditComponentName,
    contractEditComponentOptions
  )
  .component(
    MachineDetailMachinesEditComponentName,
    MachineDetailMachinesEditComponentOptions
  )

  .component(
    MachineDetailMachinesViewComponentName,
    MachineDetailMachinesViewComponentOptions
  )
  .service(selectContractModalServiceName, SelectContractModalService)
  .component(
    SelectContractModalComponentOptionsName,
    selectContractModalComponentOptions
  )
  .component(contractPatchBulkComponentName, contractPatchBulkComponentOptions)
  .component(contractGridComponentName, contractGridComponentOptions)
  .component(
    ContractPatchBulkResultName,
    contractPatchBulkResultComponentOptions
  )
  .component(contractInfoComponentName, contractInfoComponentOptions)

  .component(
    ContractMasterDetailComponentName,
    contractMasterDetailComponentOptions
  )
  .component(
    contractMasterAgreementEditComponentName,
    contractMasterAgreementEditComponentOptions
  )
  .component(
    gamingContractEditComponentName,
    gamingContractEditComponentOptions
  )
  .component(
    GamingContractMasterDetailComponentName,
    gamingContractMasterDetailComponentOptions
  )
  .component(
    gamingContractMasterAgreementEditComponentName,
    gamingContractMasterAgreementEditComponentOptions
  )


  .component(contractDetailComponentName, contractDetailComponentOptions);

export default vsName;
